import { ScheduleActivityResourceCategoryBase } from './base/schedule-activity-resource-category-base';

export class ScheduleActivityResourceCategory extends ScheduleActivityResourceCategoryBase { }